enum Periods {
    MONTHLY = 'monthly' ,
    YEARLY = 'yearly'
}

export default  Periods;